export const FETCH_TOURNAMENT_LIST_REQUEST = 'FETCH_TOURNAMENT_LIST_REQUEST';
export const FETCH_TOURNAMENT_LIST_SUCCESS = 'FETCH_TOURNAMENT_LIST_SUCCESS';
export const FETCH_TOURNAMENT_LIST_FAILURE = 'FETCH_TOURNAMENT_LIST_FAILURE';

export const FETCH_TOURNAMENT_DETAILS_REQUEST = 'FETCH_TOURNAMENT_DETAILS_REQUEST';
export const FETCH_TOURNAMENT_DETAILS_SUCCESS = 'FETCH_TOURNAMENT_DETAILS_SUCCESS';
export const FETCH_TOURNAMENT_DETAILS_FAILURE = 'FETCH_TOURNAMENT_DETAILS_FAILURE';

export const FETCH_TOURNAMENT_CALCULATION_EARNING_REQUEST =
  'FETCH_TOURNAMENT_CALCULATION_EARNING_REQUEST';
export const FETCH_TOURNAMENT_CALCULATION_EARNING_SUCCESS =
  'FETCH_TOURNAMENT_CALCULATION_EARNING_SUCCESS';
export const FETCH_TOURNAMENT_CALCULATION_EARNING_FAILURE =
  'FETCH_TOURNAMENT_CALCULATION_EARNING_FAILURE';

export const FETCH_TOURNAMENT_PRIZE_DISTRIBUTION_REQUEST =
  'FETCH_TOURNAMENT_PRIZE_DISTRIBUTION_REQUEST';
export const FETCH_TOURNAMENT_PRIZE_DISTRIBUTION_SUCCESS =
  'FETCH_TOURNAMENT_PRIZE_DISTRIBUTION_SUCCESS';
export const FETCH_TOURNAMENT_PRIZE_DISTRIBUTION_FAILURE =
  'FETCH_TOURNAMENT_PRIZE_DISTRIBUTION_FAILURE';

export const FETCH_PLAY_TOURNAMENT_REQUEST = 'FETCH_PLAY_TOURNAMENT_REQUEST';
export const FETCH_PLAY_TOURNAMENT_SUCCESS = 'FETCH_PLAY_TOURNAMENT_SUCCESS';
export const FETCH_PLAY_TOURNAMENT_FAILURE = 'FETCH_PLAY_TOURNAMENT_FAILURE';

export const FETCH_HISTORY_TOURNAMENT_LIST_REQUEST = 'FETCH_HISTORY_TOURNAMENT_LIST_REQUEST';
export const FETCH_HISTORY_TOURNAMENT_LIST_SUCCESS = 'FETCH_HISTORY_TOURNAMENT_LIST_SUCCESS';
export const FETCH_HISTORY_TOURNAMENT_LIST_FAILURE = 'FETCH_HISTORY_TOURNAMENT_LIST_FAILURE';

export const FETCH_HISTORY_TOURNAMENT_DETAILS_REQUEST = 'FETCH_HISTORY_TOURNAMENT_DETAILS_REQUEST';
export const FETCH_HISTORY_TOURNAMENT_DETAILS_SUCCESS = 'FETCH_HISTORY_TOURNAMENT_DETAILS_SUCCESS';
export const FETCH_HISTORY_TOURNAMENT_DETAILS_FAILURE = 'FETCH_HISTORY_TOURNAMENT_DETAILS_FAILURE';
